'use client';
import React from 'react';
import {
    listPath,
    listTitle,
    listTarget,
    descriptionBlock,
    listProcess,
    implementationBlock,
    implementationBlock2,
    textBlock,
    imageBlock,
    textBlock2,
    quoteBlock,
    textBlock3,
    resultBlock,
    resultBlock2,
    developmentBlock,
    listTeam,
    iconsBlock,
    nextProjectFrt,
} from './contstants';

import QuoteBlock from '../reusable-components/layouts-components__frt-service/quote-block';
import './style.sass';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import BlocksIcons from '../reusable-components/layouts-components__frt-service/blocks-icons';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import OfferButton from '../../../../../shared/sections/OfferButton';
import TitleCase from '../../case-components/title-case';
import TargetCase from '../../case-components/target-case';
import CaseBlock from '../../case-components/case-block';
import ProcessCase from '../../case-components/process-case';
import DiagrammCase from '../../case-components/diagramm-case';
import TeamCase from '../../case-components/team-case';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import BannerFillWidth from '../../case-components/banner-full-width';
const FrtService = () => {
    return (
        <div className="frt-service">
            <TitleCase
                img="/images/pic/frtService/banner.jpg"
                listPath={listPath}
                listTitle={listTitle}
                caseName="frt-service__first-screen"
            />
            <TargetCase listTarget={listTarget} />
            <CaseBlock
                params={descriptionBlock}
                className={'frt-service__desc'}
                isBorder={false}
                isTop={true}
            />
            <div className="frt-service__tasks">
                <ProcessCase listProcess={listProcess} />
            </div>
            <CaseBlock params={implementationBlock} className={'frt-service__implementation'} />
            <CaseBlock params={implementationBlock2} className={'frt-service__implementation'} />
            <BannerFillWidth
                banner="/images/pic/frtService/bannerImp.jpg"
                alt={'Фрт'}
                customClass={'frt-service__banner'}
            />
            <CaseBlock params={textBlock} className={'frt-service__block'} />
            <DiagrammCase params={imageBlock} className={'frt-service__diagramm'} />
            <CaseBlock params={textBlock2} className={'mt-60'} />
            <QuoteBlock params={quoteBlock} />
            <CaseBlock params={textBlock3} />
            <CaseBlock params={resultBlock} className={'frt-service__results'} />
            <CaseBlock params={resultBlock2} />
            <BlocksIcons list={iconsBlock} className={'frt-service__icons-block'} />
            <CaseBlock params={developmentBlock} className={'frt-service__development'} />
            <TeamCase listTeam={listTeam} />
            <ScrollAnimation>
                <FullWrapper>
                    <OfferButton linkText="Нанять команду" />
                </FullWrapper>
            </ScrollAnimation>
            <NextProject NextProject={nextProjectFrt} />
        </div>
    );
};
export default FrtService;
